import { Injectable } from "@angular/core";
import * as moment from 'moment';

@Injectable()
export class Sortable {
  tableDataStructure = [];

  tableDataSort = {
    key: 'none',
    order: 'ascending'
  };

  sortClass(key) {
    if (this.tableDataSort.key === key) {
      return '--is-' + this.tableDataSort.order;
    }
  }

  sortBy(key) {
    if (this.tableDataSort.key === key) {
      if (this.tableDataSort.order === 'ascending') {
        this.tableDataSort.order = 'descending';
      } else {
        this.tableDataSort = {
          key: 'none',
          order: 'ascending'
        };
      }
    } else {
      this.tableDataSort.key = key;
    }
  }

  sorted(data) {
    if (data.length === 0) {
      return data;
    }

    let finalData = data.slice(0);
    let sortKey = this.tableDataSort.key;

    if (sortKey !== 'none') {
      finalData = finalData.sort((a, b) => {
        let normalisedA;
        let normalisedB;
        let field = this.tableDataStructure.find(field => field.id === sortKey);

        switch (field.type) {
          case 'date':
            if (typeof a[sortKey] === 'string') {
              normalisedA = moment(a[sortKey], 'MMMM DD, YYYY').valueOf();
            } else {
              normalisedA = moment(a[sortKey]).valueOf();
            }

            if (typeof b[sortKey] === 'string') {
              normalisedB = moment(b[sortKey], 'MMMM DD, YYYY').valueOf();
            } else {
              normalisedB = moment(b[sortKey]).valueOf();
            }
            break;

          case 'number':
            normalisedA = Number(a[sortKey]);
            normalisedB = Number(b[sortKey]);
            break;

          default:
            normalisedA = String(a[sortKey])
              .toLowerCase()
              .trim();
            normalisedB = String(b[sortKey])
              .toLowerCase()
              .trim();
            break;
        }

        return this.doSorting(
          normalisedA,
          normalisedB,
          this.tableDataSort.order
        );
      });
    }

    return finalData;
  }

  doSorting(a, b, order: string) {
    if (a < b) {
      if (order === 'ascending') {
        return -1;
      } else {
        return 1;
      }
    } else if (a > b) {
      if (order === 'ascending') {
        return 1;
      } else {
        return -1;
      }
    } else {
      return 0;
    }
  }
}
